<template>
  <div v-resize="resizeWidth" class="tags-view-container flexCB">
    <div ref="tagsViewContainer" class="tags-view-show flexC">
      <!-- isLast属性是给css属性选择器用的不要删除 -->
      <link-tag
        v-for="(item, index) in visitedViews"
        ref="tag"
        :key="item.path"
        :index="index"
        :info="item"
        :style="tagStyle_(index)"
        :is-last="tagsCut? hadAddEnd_ && index === endIndex_ : false"
        :is-hidden="tagsCut? index > endIndex_ : false"
        :tags-cut="tagsCut"
        @closeTags="closeTags(item)"
        @dragStart="dragStart($event, index)"
        @drop="drop($event, index, visitedViews)"
        @openMenu="openMenu(item, $event, 0)"
      />
    </div>
    <el-popover
      v-if="tagsCut"
      v-model="showPopover"
      width="140"
      class="tags-view-other"
      :class="{'hidden': !otherVisitedViews_.length}"
      popper-class="tags-view-el-popover"
      trigger="click"
    >
      <div class="tags-view-container flex-v">
        <TagsMenu
          v-show="visible[1]"
          :right-menu-left="rightMenuLeft"
          :right-menu-top="rightMenuTop"
          :selected-tag="selectedTag"
          @onMenu="handleRightMenu"
        />
        <link-tag
          v-for="(item, index) in otherVisitedViews_"
          :key="item.path"
          :index="index"
          :info="item"
          :is-fixed="index === 0"
          :tags-cut="true"
          @dragStart="dragStart($event, otherDropIndex_(index))"
          @drop="drop($event, otherDropIndex_(index), visitedViews)"
          @closeTags="closeTags(item)"
          @openMenu="openMenu(item, $event, 1)"
        />
      </div>
      <template slot="reference">
        <div class="tags-popover-btn" :class="{'active': showPopover}"><i class="el-icon-more" /></div>
      </template>
    </el-popover>
    <TagsMenu
      v-show="visible[0]"
      :right-menu-left="rightMenuLeft"
      :right-menu-top="rightMenuTop"
      :selected-tag="selectedTag"
      @onMenu="handleRightMenu"
    />
  </div>
</template>

<script>
import path from 'path'
import LinkTag from './LinkTag'
import TagsMenu from './TagsMenu'
import { tagsMixins } from './tagsMixins.js'

export default {
  name: 'TagsView',
  components: { LinkTag, TagsMenu },
  // components: { ScrollPane },
  mixins: [tagsMixins],
  props: {
    allMenu: {
      type: Array,
      default: () => []
    },
    // 所有菜单
    allRoutes: {
      type: Array,
      default: () => []
    },
    visitedViews: {
      type: Array,
      default: () => []
    },
    cachedViews: {
      type: Array,
      default: () => []
    },
    isCollapse: {
      type: Boolean,
      default: false
    },
    tagsCut: { // 多余菜单 额外显示
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: [false, false],
      rightMenuTop: 0,
      rightMenuLeft: 0,
      selectedTag: {},
      affixTags: [],
      rePage: '',
      showPopover: false,
      containerWidth: 0,
      timeout: null,
      sizeRecord: {}, // 记录所有item项的信息，
      maxOtherWidth: 60,
      otherWidth: 0, // 剩下的宽度
      prevFullPath: ''
    }
  },
  computed: {
    endIndex_() {
      let containerWidth = this.containerWidth
      let index = this.visitedViews.length - 1
      let otherWidth = 0
      this.visitedViews.some((v, i) => {
        const meta = v.meta || {}
        const recodeItem = this.sizeRecord[`${v.title}${meta.affix || ''}${v.path}`] || {}
        const width = recodeItem.offsetWidth || 0
        otherWidth = containerWidth
        containerWidth -= width
        if (containerWidth > 0) {
          index = i
          return false
        }
        this.otherWidth = otherWidth
        return true
      })
      if (otherWidth >= this.maxOtherWidth) {
        return index + 1
      }
      return index
    },
    otherDropIndex_() {
      return (index) => {
        return index + this.endIndex_ + 1
      }
    },
    hadAddEnd_() {
      return this.otherWidth >= this.maxOtherWidth
    },
    otherVisitedViews_() {
      return this.visitedViews.slice(this.endIndex_ + 1)
    },
    tagStyle_() {
      return (index) => {
        if (this.hadAddEnd_ && index === this.endIndex_ && this.tagsCut) {
          return {
            width: `${this.otherWidth}px`,
            marginRight: '0'
          }
        } else {
          return {}
        }
      }
    }
  },
  // computed: {
  //   ...mapGetters(['sidebar', 'visitedViews']),
  //   visitedViews () {
  //     return this.$store.state.tagsView.visitedViews
  //   },
  //   cachedViews () {
  //     return this.$store.state.tagsView.cachedViews
  //   },
  //   routes () {
  //     return this.$store.state.permission.routes
  //   }
  // },
  watch: {
    $route(now, old) {
      this.prevFullPath = old.fullPath
      this.addVisitedTag(this.$route)
      // this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    },
    visitedViews: {
      immediate: true,
      handler(nval) {
        this.$nextTick(() => {
          const sizeRecord = { ...this.sizeRecord }
          this.$refs['tag'].forEach((e, i) => {
            const index = e.$el.getAttribute('index')
            const item = this.visitedViews[index]
            const meta = item.meta || {}
            const key = `${item.title}${meta.affix || ''}${item.path}`
            if (!sizeRecord[key]) {
              // title affix path 三个拼接当作key
              sizeRecord[key] = { offsetWidth: e.$el.offsetWidth + 8 }
            }
          })
          this.sizeRecord = sizeRecord
        })
      }
    },
    isCollapse(nval) {
      setTimeout(() => {
        this.containerWidth = this.$refs.tagsViewContainer.clientWidth
      }, 1000)
    }
  },
  mounted() {
    this.containerWidth = this.$refs.tagsViewContainer.clientWidth
    this.initTags()
    let indexRouter = this.allRoutes.find(v => v.path === '/')
    // 获取重定向后的首页路由信息
    if (indexRouter && indexRouter.redirect) {
      indexRouter = this.getRouter(indexRouter.redirect, this.allRoutes)
    }
    // 插入首页tag
    if (indexRouter) {
      indexRouter.fullPath = indexRouter.path
      this.addVisitedTag(indexRouter)
    }
    this.addVisitedTag(this.$route)
    // actions.onGlobalStateChange(state => {
    //   console.log('state---', state)
    //   if (!state.g6_visible) {
    //     this.closeTags({ path: '/editor/flow' })
    //   }
    //   if (state.deleteCurrent) {
    //     console.log('this.$refs.closeTag[0].$attrs', this.$refs.closeTag[0].$attrs['data-tag'])
    //     this.closeTags(this.$refs.closeTag[0].$attrs['data-tag'])
    //     actions.setGlobalState({ deleteCurrent: false })
    //     this.rePage = state.rePage
    //   }
    // })
  },
  methods: {
    getRouter(path, routers) {
      if (!routers) return null
      let reuslt = null
      var rootList = [...routers]
      // 广度遍历 获取
      while (rootList.length && reuslt === null) {
        const childrenList = []
        while (rootList.length && reuslt === null) {
          const nroot = rootList.shift()
          if (nroot.path === path) {
            reuslt = nroot
          }
          nroot.children && childrenList.push(...nroot.children)
        }
        if (childrenList.length) {
          rootList.push(...childrenList)
        }
      }
      // 获取到的值若还存在重定向则继续查找
      const redirect = reuslt && reuslt.redirect
      if (redirect) {
        return this.getRouter(redirect, this.allRoutes)
      }
      return reuslt
    },
    // 点击右键菜单
    handleRightMenu(type, item) {
      this.closeMenu()
      switch (type) {
        case 'refresh':
          this.refreshTags(item)
          break
        case 'close':
          this.closeTags(item)
          break
        case 'others':
          this.closeOthersTags(item)
          break
        case 'all':
          this.closeAllTags()
          break
        case 'left':
          this.closeLeftTags(item)
          break
        case 'right':
          this.closeRightTags(item)
          break
      }
    },
    // 刷新页签
    refreshTags(item) {
      this.deleteCachedTag(item).then(() => {
        const { fullPath } = item
        this.$nextTick(() => {
          this.$router
            .replace({ path: '/redirect' + fullPath })
            .then(() => {
              if ('/redirect' + fullPath === this.$route.fullPath) {
                this.$emit('refreshTagsActions')
                // actions.setGlobalState({ refreshTags: true })
              }
            })
            .catch((err) => {
              console.log('err--', err)
            })
        })
      })
    },
    // 关闭页签
    closeTags(item) {
      item && this.deleteVisitedTag(item).then((visitedViews) => {
        if (this.isActive(item)) {
          this.toLastTag(visitedViews)
        }
      })
      // 触发resize事件
      // this.$nextTick(() => {
      //   const myEvent = new CustomEvent('menuResize', {
      //     detail: {
      //       isOpened: this.sidebar.opened,
      //       visitedViews: this.visitedViews
      //     },
      //     bubbles: true,
      //     cancelable: false
      //   })
      //   window.dispatchEvent(myEvent)
      // })
    },
    // 关闭其他页签
    closeOthersTags(tag) {
      this.$router.push(tag)
      this.deleteOthersVisitedTags(tag).then(() => {
        // this.moveToCurrentTag()
      })
    },
    // 关闭全部页签
    closeAllTags() {
      this.deleteAllVisitedTags().then(visitedViews => {
        this.toLastTag(visitedViews)
      })
    },
    // 关闭左边页签
    closeLeftTags(item) {
      this.deleteLeftVisitedTags(item)
    },
    // 关闭右边页签
    closeRightTags(item) {
      this.deleteRightVisitedTags(item).then((visitedViews) => {
        this.toLastTag(visitedViews)
      })
    },
    // 是否是当前页
    isActive(item) {
      return item.fullPath === this.$route.fullPath
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            // name: route.name,
            meta: { ...route.meta }
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    // 更新页签
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            // this.$refs.scrollPane.moveToTarget(tag)
            if (tag.to.fullPath !== this.$route.fullPath) {
              // this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },
    // 跳转到最后一个页签
    toLastTag(visitedViews) {
      const latestView = visitedViews.slice(-1)[0]

      if (this.prevFullPath) {
        const prevView = visitedViews.find(item => item.fullPath === this.prevFullPath)

        if (prevView) {
          this.$router.push(prevView)
          return
        }
      }

      if (this.rePage) {
        this.$router.push(this.rePage)
        this.rePage = ''
      } else if (latestView) {
        this.$router.push(latestView)
      } else {
        this.$router.push('/')
      }
    },
    // 打开右键菜单
    openMenu(tag, e, index) {
      const left = e.clientX
      this.rightMenuLeft = left
      this.rightMenuTop = e.clientY
      this.selectedTag = tag
      const visible = [false, false]
      visible[index] = true
      this.visible = visible
    },
    // 关闭右键菜单
    closeMenu() {
      this.visible = [false, false]
    },
    // 拖拽
    allowDrop(e) {
      e.preventDefault()
    },
    dragStart(e, index) {
      this.visible = [false, false]
      index !== 0 && e.dataTransfer.setData('index', index)
    },
    drop(e, index, data) {
      this.allowDrop(e)
      const dragIndex = Number(e.dataTransfer.getData('index'))
      if (index !== 0 && dragIndex !== 0) {
        const temp = data.splice(dragIndex, 1)
        data.splice(index, 0, temp[0])
      }
      this.setVisitedView(data)
      // this.$store.dispatch('tagsView/setVisitedView', data)
    },
    initTags() {
      const affixTags = (this.affixTags = this.filterAffixTags(this.allMenu))
      for (const tag of affixTags) {
        if (tag.path) {
          // this.$store.dispatch('tagsView/addVisitedView', tag)
          this.addVisitedTag(tag)
        }
      }
    },
    resizeWidth() {
      this.containerWidth = this.$refs.tagsViewContainer.clientWidth
    },
    // 关闭当前标签页(外部调用不要删)
    closeCurrentTag() {
      const item = this.visitedViews.find(v => v.fullPath === this.$route.fullPath)
      this.closeTags(item)
    }
  }
}
</script>
